import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { editInquiryInfo, getInquiryById } from "../../../../redux/features/inquiries/inquiriesService";
import styles from './index.module.css';
import BeatLoader from "react-spinners/BeatLoader";
import GridLoader from "react-spinners/GridLoader";
import { showToast } from "../../../../components/ToastMsg";

const ViewInquiry = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const { isInquiryLoading, inquiry } = useSelector((state) => state.inquiry.inquiryDetails);
    const { isInquiryUpdateing } = useSelector((state) => state.inquiry.updateInquiryDetails);

    const [isProgressLoading, setProgressLoading] = useState(false);
    const [isRejectLoading, setRejectLoading] = useState(false);
    const [isCompleteLoading, setCompleteLoading] = useState(false);

    useEffect(() => {
        dispatch(getInquiryById({ id: id }));
    }, [dispatch, id]);

    const clickUpdate = async (value) => {
        if (value === 'INPROGRESS') {
            setProgressLoading(true);
        }
        if (value === 'REJECTED') {
            setRejectLoading(true);
        }
        if (value === 'COMPLETED') {
            setCompleteLoading(true);
        }
        try {
            const data = {
                id: id,
                status: value
            }
            const response = await dispatch(editInquiryInfo(data)).unwrap();
            if (response.success === true) {
                showToast('success', response.message);
                dispatch(getInquiryById({ id: id }));
                setProgressLoading(false);
                setRejectLoading(false);
                setCompleteLoading(false);
            }
        } catch (error) {
            showToast('error', error.message);
            setProgressLoading(false);
            setRejectLoading(false);
            setCompleteLoading(false);
        }
    }

    return (
        <div className={`main-card`}>
            <div className={`main-card-body`}>
                <h1 className={`form-title ${styles.headDiv}`}>
                    Inquiry Details
                </h1>
            </div>
            {isInquiryLoading ?
                <div className={`loader-style`}>
                    <GridLoader color="#c93b25" />
                </div>
                :
                <>
                    <div className={styles.tableWrapper}>
                        <table className={styles.table}>
                            <tbody className={styles.tbody}>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Name</td>
                                    <td className={styles.tdataColumnTwo}>{inquiry?.name}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Email Address</td>
                                    <td className={styles.tdataColumnTwo}>{inquiry?.email}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Phone Number</td>
                                    <td className={styles.tdataColumnTwo}>{inquiry?.phone_number}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Message</td>
                                    <td className={styles.tdataColumnTwo} style={{ fontWeight: 'bold' }}>{inquiry?.message}</td>
                                </tr>
                                <tr className={styles.msgRow}>
                                    <td className={styles.tdataColumnOne}>Message</td>
                                    <td className={styles.tdataColumnTwo}>{inquiry?.message}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Status</td>
                                    <td className={styles.tdataColumnTwo}> <span className={`status-text-label ${inquiry?.status?.toLowerCase()}`}>{inquiry?.status}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className={styles.btnRow}>
                        <button
                            className={`btn-primary`}
                            type='button'
                            disabled={isInquiryUpdateing}
                            onClick={() => clickUpdate('INPROGRESS')}
                        >
                            {isProgressLoading ? (
                                <BeatLoader grade='#ffffff' />
                            ) : (
                                `In Progress`
                            )}
                        </button>
                        <button
                            className={`btn-primary`}
                            type='button'
                            disabled={isInquiryUpdateing}
                            onClick={() => clickUpdate('REJECTED')}
                            style={{ backgroundColor: "var(--danger", borderColor: "var(--danger" }}
                        >
                            {isRejectLoading ? (
                                <BeatLoader grade='#ffffff' />
                            ) : (
                                `Reject`
                            )}
                        </button>
                        <button
                            className={`btn-primary`}
                            type='button'
                            disabled={isInquiryUpdateing}
                            onClick={() => clickUpdate('COMPLETED')}
                            style={{ backgroundColor: "var(--green", borderColor: "var(--green" }}
                        >
                            {isCompleteLoading ? (
                                <BeatLoader grade='#ffffff' />
                            ) : (
                                `Complete`
                            )}
                        </button>
                    </div>
                </>
            }
        </div>
    )
}

export default ViewInquiry;